module.exports = __webpack_public_path__ + "static/other/gameDiseasedTrees.675edfa5.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameDiseasedTrees.json
// module id = 912
// module chunks = 0